import { render, staticRenderFns } from "./SoglasheniePoSkidkeIDopam.vue?vue&type=template&id=42651fa5&scoped=true&"
import script from "./SoglasheniePoSkidkeIDopam.vue?vue&type=script&lang=js&"
export * from "./SoglasheniePoSkidkeIDopam.vue?vue&type=script&lang=js&"
import style0 from "./SoglasheniePoSkidkeIDopam.vue?vue&type=style&index=0&id=42651fa5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42651fa5",
  null
  
)

component.options.__file = "SoglasheniePoSkidkeIDopam.vue"
export default component.exports